import { BrowserUtils } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Link } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getErrMsg, toastNeg } from '../../common/toastHelper'
import { useStore } from '../../Provider'
import '../styles/gdpr.scss'
import { MuiButtonVariants, OPButton } from './OPButton'

export const GDPR = observer((): JSX.Element => {
  const { instance } = useMsal()

  const { t } = useTranslation()
  const rootStore = useStore()

  const { validatedUser, acceptTerms, showTermsModal, setShowTermsModal } = rootStore.loginStore

  const accept = async () => {
    try {
      await acceptTerms(validatedUser)
      setShowTermsModal(false)
    } catch (error) {
      toastNeg(getErrMsg(error, t) || t('Toasts.TermsError'))
    }
  }

  if (!showTermsModal) {
    return <></>
  }

  return (
    <Dialog className='gdpr__dialog' aria-labelledby='privacy-policy' aria-describedby='privacy-policy' open={showTermsModal}>
      <DialogTitle className='gdpr__dialog__title'>{t('Terms.Title')}</DialogTitle>
      <DialogContent className='gdpr__dialog__content'>
        <div>
          <div>{t('Terms.ContentText')}</div>
          <div>
            <Link
              className='tsFont'
              underline='none'
              target='_blank'
              href='https://netum.sharepoint.com/henkilosto/SitePages/Ty%C3%B6ntekij%C3%A4n-tietosuoja.aspx'
              rel='noopener noreferrer'
            >
              <span className='gdpr__dialog__content--clickable'>
                {t('Terms.ShowPolicy')} {t('Terms.ShowTermsText')}
              </span>
            </Link>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <OPButton
          label={t('Buttons.Decline')}
          buttonVariant={MuiButtonVariants.error}
          onClick={() =>
            instance.logoutRedirect({
              account: instance.getActiveAccount(),
              onRedirectNavigate: () => !BrowserUtils.isInIframe(),
            })
          }
        />
        <OPButton label={t('Buttons.ApproveVersion')} buttonVariant={MuiButtonVariants.primary} onClick={() => accept()} />
      </DialogActions>
    </Dialog>
  )
})
